<div [dir]="options.dir!">
  <mat-sidenav-container
    class="mainWrapper"
    autosize
    autoFocus
    [ngClass]="{
      'sidebarNav-mini': options.sidenavCollapsed,
      green_theme: options.activeTheme == 'green_theme',
    }"
  >
    @if (!options.horizontal) {
      <mat-sidenav
        #leftsidenav
        [mode]="isOver ? 'over' : 'side'"
        [opened]="
          options.navPos === 'side' &&
          options.sidenavOpened &&
          !isOver &&
          !resView
        "
        (openedChange)="onSidenavOpenedChange($event)"
        class="sidebarNav"
      >
        <ng-scrollbar class="position-relative" style="height: 100%">
          <div class="iconMenu">
            <app-iconmenu
              [menuItems]="menuItems"
              (toggleCollapsed)="toggleCollapsed()"
              (iconSelected)="onIconSelected($event)"
            ></app-iconmenu>
          </div>

          <div class="flex-layout inner-sidebar">
            <app-sidebar
              (toggleMobileNav)="sidenav.toggle()"
              [showToggle]="isOver"
            ></app-sidebar>

            <ng-scrollbar class="position-relative" style="height: 100%">
              <mat-nav-list class="sidebar-list">
                @for (item of menuItems; track item) {
                  @if (selectedIcon === item.menu_position) {
                    @for (program of item.programs; track program) {
                      <app-nav-item
                        [item]="program"
                        (notify)="sidenav.toggle()"
                      >
                      </app-nav-item>
                    }
                  }
                }
              </mat-nav-list>
            </ng-scrollbar>
          </div>
        </ng-scrollbar>
      </mat-sidenav>
    }

    <mat-sidenav-content class="contentWrapper" #content>
      @if (!options.horizontal) {
        <app-header
          (toggleCollapsed)="toggleCollapsed()"
          (toggleMobileNav)="sidenav.toggle()"
          (toggleMobileFilterNav)="filterNavRight.toggle()"
        ></app-header>
        <mat-drawer
          #filterNavRight
          mode="over"
          position="end"
          class="filter-sidebar"
        >
          <button
            mat-icon-button
            (click)="filterNavRight.toggle()"
            class="d-flex justify-content-center"
          >
            <i-tabler name="x" class="icon-18 d-flex"></i-tabler>
          </button>
        </mat-drawer>
      }

      <div class="body-wrapper">
        <main
          class="pageWrapper"
          [ngClass]="{
            maxWidth: isPageCentered(),
            fullWidth: !isPageCentered(),
          }"
        >
          <router-outlet></router-outlet>
        </main>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
